import { InvestigationTone } from "@ibada/shared-types/investigation"
import type { TimelineTone } from "@ibada/ui"

/** Map the contract's tone to the shared Timeline's tone. */
export function toTimelineTone(tone: string): TimelineTone {
  switch (tone) {
    case InvestigationTone.Success:
      return "success"
    case InvestigationTone.Destructive:
      return "destructive"
    case InvestigationTone.Warning:
      return "warning"
    case InvestigationTone.Info:
      return "info"
    case InvestigationTone.Muted:
      return "muted"
    default:
      return "default"
  }
}

type BadgeVariant = "default" | "secondary" | "success" | "destructive" | "outline"

/** Map the contract's tone to a Badge variant. */
export function toBadgeVariant(tone: string): BadgeVariant {
  switch (tone) {
    case InvestigationTone.Success:
      return "success"
    case InvestigationTone.Destructive:
      return "destructive"
    case InvestigationTone.Muted:
      return "outline"
    default:
      return "secondary"
  }
}
